export const breakpoints = {
  xxxs: 370,
  xxs: 480,
  xs: 640,
  sm: 768,
  md: 1024,
  lg: 1200,
  xl: 1536,
}
